// extracted by mini-css-extract-plugin
module.exports = {"oembed-cover":"_Oembed_oembed-cover_11c3W","oembed":"_Oembed_oembed_1gvrl"};